import { useLocalStorage } from "@/hooks/useLocalStorage";
import { X } from "@phosphor-icons/react";

interface AnnouncementBannerProps {
  id: string;
  children: React.ReactNode;
}

/**
 * Dismissible top announcement banner.
 * Dismissal is persisted in localStorage keyed by `id`.
 */
export function AnnouncementBanner({ id, children }: AnnouncementBannerProps) {
  const storageKey = `announcement-dismissed-${id}`;
  const [dismissed, setDismissed] = useLocalStorage(storageKey, false);

  if (dismissed) return null;

  return (
    <div className="bg-primary/10 border-b border-primary/20 px-4 py-2 text-center text-sm text-primary relative">
      <span>{children}</span>
      <button
        onClick={() => setDismissed(true)}
        className="absolute right-3 top-1/2 -translate-y-1/2 p-1 rounded hover:bg-primary/20 transition-colors"
        aria-label="Dismiss announcement"
      >
        <X size={14} />
      </button>
    </div>
  );
}
